<template>
  <b-card class="p-1">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <b-form-group class="w-50 mb-0">
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Wyszukaj zamówienie" @input="debouncedSearch" />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="clearSearch"> Wyczyść </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table
      responsive
      bordered
      striped
      hover
      :items="cooperationRecords"
      :fields="fields"
      :busy="isLoading">
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Wczytywanie...</strong>
        </div>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex flex-column align-items-center">
          <b-button
            :to="{ name: 'orders-show', params: { id: row.item.id } }"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="btn table-btn"
            size="sm">
            Zobacz
          </b-button>
        </div>
      </template>
    </b-table>
    
    <!-- Pagination controls -->
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <span>Pokazuje {{ cooperationRecords.length }} z {{ total }} rekordów</span>
      <b-pagination
        v-model="page"
        :total-rows="total"
        :per-page="perPage"
        @change="handlePageChange"
        aria-controls="orders-table"
        class="mb-0"
      ></b-pagination>
      <b-form-select
        v-model="perPage"
        :options="perPageOptions"
        @change="handlePerPageChange"
        size="sm"
        class="w-auto"
      ></b-form-select>
    </div>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';

import { all } from '@/http/orders';

import { StatusFormatter } from '@/formatters/StatusFormatter';
import { BSpinner, BTable, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BFormSelect, BPagination } from 'bootstrap-vue';

export default {
  mixins: [NotificationMixin],
  components: {
    BSpinner,
    BTable,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormSelect,
    BPagination,
  },

  data() {
    return {
      cooperationRecords: [],
      filter: '',
      filterOn: [],
      fields: [
        { key: 'tetaOrderNumber', label: 'TETA ID', sortable: true },
        { key: 'orderData.email', label: 'Email', sortable: true },
        { key: 'orderData.phone', label: 'Telefon', sortable: true },
        { key: 'total_price', label: 'Wartość', sortable: true },
        { key: 'delivery_price', label: 'Wartość dostawy', sortable: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          formatter: (value, key, item) => {
            return StatusFormatter(item);
          },
        },
        { key: 'payment_method', label: 'Płatność', sortable: true },
        { key: 'delivery_method', label: 'Sposób dostawy', sortable: true },
        { key: 'created_at', label: 'Data złożenia', sortable: true },
        { key: 'actions', label: 'Akcje', class: 'w-25' },
      ],
      isLoading: false,
      total: 0,
      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchTimeout: null,
    };
  },

  async mounted() {
    this.fetchOrders();
  },

  methods: {
    async fetchOrders() {
      try {
        this.isLoading = true;
        const params = {
          page: this.page,
          perPage: this.perPage,
          query: this.filter
        };
        
        const { data } = await all(params);

        this.cooperationRecords = data.data;
        this.total = data.meta.total;
        this.perPage = data.meta.per_page;
        this.page = data.meta.current_page;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem zgłoszeń współpracy. Skontaktuj się ze swoim developerem.',
        );
      } finally {
        this.isLoading = false;
      }
    },

    debouncedSearch() {
      // Clear any existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      // Set a new timeout
      this.searchTimeout = setTimeout(() => {
        this.page = 1; // Reset to first page when search changes
        this.fetchOrders();
      }, 500); // 500ms debounce time
    },

    clearSearch() {
      this.filter = '';
      this.page = 1;
      this.fetchOrders();
    },

    handlePageChange(page) {
      this.page = page;
      this.fetchOrders();
    },

    handlePerPageChange() {
      this.page = 1; // Reset to first page when changing items per page
      this.fetchOrders();
    }
  },
};
</script>
